<i18n src="@/locales/models/container.yml" lang="yaml"></i18n>
<i18n
  src="@/locales/views/packing_house/production/final_packing_list_simplified/show_process.yml"
  lang="yaml"
></i18n>
<template>
  <div class="mt-4">
    <h1 class="page-title">
      <i class="fa-solid fa-container-storage"></i
      ><span class="space-icon"></span>
      {{ $t("labels.containers_title") }}
    </h1>

    <div class="mt-4 flex flex-row">
      <div class="panel-plain-label">
        <badge-default
          :label="total + ' ' + $t('labels.total_number_containers')"
        />
      </div>
    </div>

    <div class="mt-2 flex flex-col">
      <ag-grid-vue
        style="height: 600px"
        class="ag-theme-alpine"
        @grid-ready="onGridReady"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="containers"
      >
      </ag-grid-vue>
    </div>

    <table-paginator
      v-model="current_page"
      v-if="Number(total) > 0"
      :total_rows="total"
      :rows_per_page="rowsPerPage.packages_from_stock"
    >
    </table-paginator>
  </div>
</template>

<script>
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { AgGridVue } from "ag-grid-vue3";
import TablePaginator from "@/components/views/layout/TablePaginator.vue";

export default {
  name: "PHProductionFinalPackingListSimplifiedShowProcessContainers",
  components: { AgGridVue, TablePaginator },
  data() {
    return {
      current_page: this.currentPage.containers,
      defaultColDef: {
        sortable: true,
        filter: true,
        floatingFilter: true,
      },
      columnDefs: [
        {
          headerName: this.$t("model.container.week"),
          field: "week",
          filter: "agNumberColumnFilter",
          width: 50,
        },
        {
          headerName: this.$t("model.container.agro_exporter"),
          field: "agro_exporter.name",
          filter: "agNumberColumnFilter",
          width: 50,
        },
        {
          headerName: this.$t("model.container.container_code"),
          field: "container_code",
          filter: true,
          cellRendererSelector: (params) => {
            const packing_house_id = this.packing_house_id;
            const packing_house_process_id = this.packing_house_process_id;
            const GoToLink = {
              template: `<span @click="this.goToShowContainer()" class="link">${params.value}</span>`,
              methods: {
                goToShowContainer: function () {
                  this.$router.push({
                    name: this.routeName("show_container"),
                    params: {
                      packing_house_id: packing_house_id,
                      packing_house_process_id: packing_house_process_id,
                      container_id: params.data.id,
                    },
                  });
                },
              },
            };
            return {
              component: GoToLink,
            };
          },
        },
        {
          headerName: this.$t("model.container.exporter_process_crop_category"),
          field: "category_name",
          filter: true,
        },
        {
          headerName: this.$t("model.container.exporter_process_brand"),
          field: "brand_name",
          filter: true,
        },
        {
          headerName: `${this.$t("model.container.gross_weight")} (Kg)`,
          field: "gross_weight",
          filter: true,
        },
        {
          headerName: `${this.$t("model.container.net_weight")} (Kg)`,
          field: "net_weight",
          filter: true,
        }
      ],
    };
  },
  props: {
    containers: { type: Array, default: () => [] },
    packing_house_id: {},
    packing_house_process_id: {},
    currentPage: {
      type: Object,
      default: () => {
        return { containers: 1 };
      },
    },
    rowsPerPage: {
      type: Object,
      default: () => {
        return { containers: 12 };
      },
    },
    stats: {
      type: Object,
      default: () => {
        return { containers: { total: null } };
      },
    },
  },
  computed: {
    total: function () {
      return this.stats?.containers?.total || 0;
    },
  },
  watch: {
    current_page: function (newvalue) {
      let current_page = this.currentPage;
      current_page.containers = newvalue;
      this.$emit("update:currentPage", current_page);
    },
  },
  methods: {
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
      this.sizeToFit();
    },
    sizeToFit() {
      this.gridApi.sizeColumnsToFit({ defaultMinWidth: 150 });
    },
  },
};
</script>
